import { webApiWithResponse } from "../../../../core/http/httpThunks";
import { OrderIndData } from "../types";

export const updateOrderIndApi = (userId: string, orderInd: OrderIndData) =>
  webApiWithResponse<string>({
    method: "PUT",
    url: "order/updateorderindicative",
    params: {
      userId,
    },
    data: orderInd,
  });

export default updateOrderIndApi;
